import React from 'react';
import InfoContainter from '../InfoContainter/InfoContainer';
import Link from '../Typography/Link/Link';
import { className } from './utils';
import cn from 'classnames'
import './LinkedList.css'

export type InfoRow = {
  title: string | React.ReactNode,
  content: string | React.ReactNode
}

export type LinkedListProps = {
  count?: string | number | React.ReactNode
  className?: string
  listData: InfoRow[]
  heading?: string
  seeMore?: Function
  contentFontColor?: "base" | "secondary" | "tertiary" | "black"
  contentFontSize?: "tiny" | "small" | "medium" | "large"
  testId?: string
  openReferenceMap?: Function
  params?: any
  isReferenceMapEnabled?: boolean
}


const LinkedList = (props: LinkedListProps) => {

  const { count, listData, heading, seeMore, contentFontColor = "black", contentFontSize = "large", testId = "cs-linkedlist", openReferenceMap = () => {}, params, isReferenceMapEnabled = false } = props;

  const classNames = cn(`LinkedList ${props.className || ''}`, className)
  return (
    <div data-test-id={testId} className={classNames}>
      {heading || count ?
        <div className="flex-v-center">
          {heading && <div className="LinkedList__heading">{heading}</div>}
          {count && <div className="LinkedList__count">{count}</div>}
        </div> : null
      }
      {params && openReferenceMap && isReferenceMapEnabled && <Link className={`${listData.length > 0 ? 'mt' : 'mb'}`} testId='cs-edit-entry-info-ref-tree-venus' type="external" target='_self' fontColor="link" cbOnClick={() => openReferenceMap(params)} iconName="OpenURL">View Reference Map</Link>}
      {listData?.length > 0 && <InfoContainter rows={listData} count={count} contentFontColor={contentFontColor} contentFontSize={contentFontSize} seeMoreCb={seeMore} />}
    </div>
  );
};

export default LinkedList;
